export const AGENT = 'AGENT';
export const VISITOR = 'VISITOR';
export const BOT = 'BOT';
export const SYSTEM = 'SYSTEM';
export const INTEGRATOR = 'INTEGRATOR';
export const EMAIL = 'EMAIL';
export const NEW_SENDER_TYPE_TO_LEGACY_SENDER_TYPE_MAP = {
  AGENT_SENDER: AGENT,
  VISITOR_SENDER: VISITOR,
  BOT_SENDER: BOT,
  SYSTEM_SENDER: SYSTEM,
  INTEGRATOR_SENDER: INTEGRATOR,
  VID_SENDER: VISITOR
};